import { SpecialityDTO } from "./Speciality.model";

export class Globals {
    static SpecialityId: number;
    static userSpecialityId: number;
    static SpecialityName: string;
    static PId: string;
    static SelectedProcedureName: string;
    static CategoryId: number;
    static LoginUsrId: number;
    static ImpersonationValue : boolean;
}

export class UserProfileDTO {
    UserName: string;
    Password: string;
    ConfirmPassword: string;
    UserId: number;
    FirstName: string;
    LastName: string;
    Email: string;
    IsFirstTimeUser: boolean;
    MobileNumber: string;
    Roles: Array<string>;
    Designation: string;
    SystemType: number;
}

export class UserDataDTO {
    Specialities: Array<SpecialityDTO>
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/UserProfile.model.ts